// Qty boleh pecahan (mis. 0,5 bal) — disimpan sampai 3 desimal; koma atau titik diterima.

export const EPS = 1e-9;

/** Bulatkan ke 3 desimal. */
export const r3 = (x: number): number => Math.round(x * 1000) / 1000;

/** Baca input qty ("0,5", "1.25", 3) → angka 3 desimal, atau NaN bila bukan angka. */
export const parseQty = (v: unknown): number => {
  const n = Number(
    String(v ?? '')
      .trim()
      .replace(',', '.'),
  );
  return Number.isFinite(n) ? r3(n) : Number.NaN;
};

export const QTY_MAX = 1e7;
